"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.urlValid = exports.URL_REGEX = void 0;
exports.URL_REGEX = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/gm;
const urlValid = (url) => {
    if (typeof url === 'string') {
        return exports.URL_REGEX.test(url);
    }
    return false;
};
exports.urlValid = urlValid;
